var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{
    'notification--hiding': _vm.state === 'hiding',
    'notification--hidden': _vm.state === 'hidden',
  },
  _vm.notifications.centerScreenNotification]},[_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }